import dayjs from "dayjs";
import { useDatetime } from "../../../../../utils/useDatetime";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { ImmunizationsActions } from "./ImmunizationActions";
import { EhrMobileGenericSection } from "../../mobile/EhrMobileGenericSection";

export function Immunizations({
  data,
  title,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const { formatToDDMMYYYY } = useDatetime;

  const columns = [
    { column: "Vacina", rowName: "vaccine" },
    { column: "Data", rowName: "date" },
    { column: "Profissional", rowName: "professional" },
  ];

  const rowData = data?.[0]?.entry?.map((el: any) => ({
    encounterId: el?.resource?.encounter?.reference?.split("/")?.[1],
    vaccine: el?.resource?.vaccineCode?.coding?.[0]?.display || "-",
    date: formatToDDMMYYYY(dayjs(el?.resource?.occurrenceDateTime)),
    status: el?.resource?.status || "-",
    professional: el?.resource?.informationSource?.reference?.display || "-",
    fullResource: el?.resource,
  }));

  return (
    <EhrMobileGenericSection
      title={title}
      columns={columns}
      rows={rowData ?? []}
      actions={
        access?.type === "patient"
          ? undefined
          : (rowData: any) => (
              <ImmunizationsActions
                row={rowData}
                openVisualizer={openVisualizer}
                verifyVisualizer={verifyVisualizer}
              />
            )
      }
    />
  );
}
